import classNames from 'classnames'

import Card from '../ui/Card/Card'
import Markdown from '../Markdown/Markdown'
import Image from '../ui/Image/Image'
import { useLanguage } from '../../context/LangaugeContextProvider/LangaugeContextProvider'
import {
  getImageUrl,
  viewDocument,
  downloadDocument,
  isArabic,
} from '../../utils'

import styles from './AnimatedImageDescriptionCard.module.scss'
import View from '../../assets/images/view.svg'
import Download from '../../assets/images/download.svg'
import { Link } from 'react-router-dom'
import { BASE_APP_URL } from '../../Contansts'

const AnimatedImageDescriptionCard = ({
  index,
  title,
  image,
  description,
  isAnimated,
  link,
  isView,
  isDownload,
  fileName,
  classname,
  animatedBgColorClass = 'bg-white',
  infoClassname,
}) => {
  const { language } = useLanguage()
  const handleView = () => {
    viewDocument(link)
  }

  const handleDownload = () => {
    downloadDocument(fileName, link)
  }

  return (
    <div
      className={classNames({
        [styles['card-container']]: isAnimated,
      })}
    >
      <Card
        key={index + title}
        className={classNames(styles.subSectionCard, classname)}
      >
        <div className={styles.imageContainer}>
          <Image src={getImageUrl(image)} alt={image?.alternativeText} />
        </div>
        <div className={classNames(styles.infoContainer, infoClassname)}>
          <span className={styles.title}>{title}</span>
          <Markdown content={description} className={styles.markdown} />
        </div>
      </Card>
      {isAnimated && (
        <div
          className={classNames(
            'absolute bottom-0 w-full flex items-center justify-end'
          )}
        >
          {link && (
            <div
              className={classNames(
                styles['animated-action-wrapper'],
                'relative',
                animatedBgColorClass,
                {
                  [styles['arabic-animated-action-wrapper']]: isArabic(
                    language?.code
                  ),
                }
              )}
            >
              <div className={classNames('flex gap-2')}>
                {isView && (
                  <Link
                    to={BASE_APP_URL + link}
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Open the document in new tab"
                  >
                    <img
                      src={View}
                      alt="View"
                      className={classNames(styles['action-image'])}
                    />
                  </Link>
                )}
                {isDownload && (
                  <img
                    src={Download}
                    alt="Download"
                    className={classNames(styles['action-image'])}
                    onClick={handleDownload}
                  />
                )}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export default AnimatedImageDescriptionCard
